import { render, staticRenderFns } from "./CellRendererViewed.vue?vue&type=template&id=c980ec5c"
import script from "./CellRendererViewed.vue?vue&type=script&lang=js"
export * from "./CellRendererViewed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports